// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rdw-image-modal{
    position: absolute;
    top: 35px;
    right: 0px !important;
    left: auto !important;
}
.editor-class {
    padding: 1rem;
    border: 1px solid #ccc;
  }`, "",{"version":3,"sources":["webpack://./src/modules/RankingAlgorithm/style.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,SAAS;IACT,qBAAqB;IACrB,qBAAqB;AACzB;AACA;IACI,aAAa;IACb,sBAAsB;EACxB","sourcesContent":[".rdw-image-modal{\n    position: absolute;\n    top: 35px;\n    right: 0px !important;\n    left: auto !important;\n}\n.editor-class {\n    padding: 1rem;\n    border: 1px solid #ccc;\n  }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
